import { useGo } from '../../app/navigation';
import { Screen } from '../../chrome';
import { BuddyCard, Question, Sub, TextLink } from '../../components';
import { useT } from '../../i18n';
import { useTrack } from '../../lib/analytics';
import { startNewCheck, updateTripDraft } from '../../lib/funnel';
import { useStage } from '../S1/trip';

/**
 * S6-stop · denied boarding without the right documents: the only pre-lead deflection.
 * No dock (nothing to continue to). "Check a different flight" starts a new check and keeps
 * the airports (prototype `newCheck('route')`, to catch a replacement flight).
 */
export default function ScreenS6Stop() {
  const t = useT();
  const go = useGo();
  const track = useTrack();
  const { enquiry, trip, hold } = useStage('S6-stop');

  function newCheck() {
    track('s6_stop_new_check');
    hold(); // the draft is about to say S2: don't let the guard race us to S1
    startNewCheck();
    updateTripDraft({ origin: trip.origin, destination: trip.destination, connections: trip.connections });
    go('S1');
  }

  return (
    <Screen id="S6-stop" title={t('S6-stop.title')}>
      <Question>{t('S6-stop.title')}</Question>
      <Sub>{t('S6-stop.sub')}</Sub>
      {/* DECISION-NEEDED: the Buddy link is the visitor's AffiliateWP link, issued at S7 (contact).
          S6-stop comes before S7, so there is none yet: the card shows only if the API has one. */}
      {enquiry?.buddyLink && <BuddyCard link={enquiry.buddyLink} />}
      <TextLink quiet onClick={newCheck}>
        {t('S6-stop.newCheck')}
      </TextLink>
    </Screen>
  );
}
